import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle, Grid } from '@mui/material';
import { ScheduleCreateContext, ScheduleCreateValues } from '../context/ScheduledReportsContext';
import { useContext } from 'react';
import { CloseDialogAction } from '../../../components/shared/dialogs/CloseDialogAction';

const PreviewModal = () => {
  const { t,
    previewModal,
    previewData,
    handleClose,
  } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  return (
    <Dialog open={previewModal}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('previewDates')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        {previewData?.map((row, index) => (
          <Grid container
            spacing={5}
            key={index}
            flexWrap={'wrap'}
            sx={{ p: '10px' }}
          >
            <Grid item
              xs={12}
              sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
              <Typography> {t('generateAt')} {row.generateAt?.substring(0, 10)} {t('reportFrom')} {row.reportFrom?.substring(0, 10)} {t('to')} {row.reportTo?.substring(0, 10)} </Typography>
            </Grid>
          </Grid>
        ))}
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}>{t('cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewModal;